const EventsByTypeChart = (data = [
  { label: 'Webinar', count: 12 },
  { label: 'Concert', count: 6 },
  { label: 'Meetup', count: 9 }
]) => ({
  tooltip: {
    trigger: 'item',
    formatter: params => {
      const { name, value, percent } = params;
      return `<b>${name}</b><br/>🎟️ Count: ${value}<br/>📊 Percent: ${percent}%`;
    }
  },
  legend: { show: false },
  series: [
    {
      name: 'Event Type',
      type: 'pie',
      radius: ['30%', '70%'],
      center: ['50%', '50%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 8,
        borderColor: '#fff',
        borderWidth: 4
      },
      label: {
        show: true,
        position: 'outside',
        formatter: '{b}: {c} ({d}%)',
        fontSize: 12
      },
      labelLine: {
        show: true,
        length: 15,
        length2: 10,
        lineStyle: {
          color: '#aaa'
        }
      },
      data: data.map(item => ({
        name: item.label,
        value: item.count
      }))
    }
  ]
});

export default EventsByTypeChart;
